import { Component, OnInit } from '@angular/core';
import {Trabalho} from "../trabalho/trabalho";
import {AcessoService} from "../acesso/acesso.service";
import {TrabalhoService} from "../trabalho/trabalho.service";
import {AppComponent} from "../app.component";
import {Router} from "@angular/router";
import {AvaliacaoService} from "../avaliacao/avaliacao.service";
import {Usuario} from "../usuario/usuario";

@Component({
  selector: 'app-avaliar-recurso-list',
  templateUrl: './avaliar-recurso-list.component.html',
  styleUrls: ['./avaliar-recurso-list.component.css'],
  providers: [
        TrabalhoService,
        AcessoService,
        AvaliacaoService
    ]
})
export class AvaliarRecursoListComponent extends AppComponent implements OnInit {

	trabalhos: Trabalho[];

	ngOnInit(): void {
		if (this.islogged() && this.isParecerista())
            this.trabalhoService.getTrabalhosByParecerista(true).then(trabalhos => (this.trabalhos = trabalhos));
        else if (this.isAdmin()) 
            this.router.navigateByUrl('inicio');
	}

}



// WEBPACK FOOTER //
// ./src/app/avaliar-recurso-list/avaliar-recurso-list.component.ts